import { useSelector } from 'react-redux'

import { skipToken } from '@reduxjs/toolkit/query'

import {
  getAuthIsLTSupervisor,
  getAuthSupervisorSelectedProviderId,
  getAuthUserId,
} from '../../../../../data/auth/authSelectors'
import { RTKQueryHook, RTKQueryResultType } from '../../../../../data/baseApi'
import { getSelectedClientId } from '../../../../../data/lyraTherapy/clientSelectors'
import { useGetClientQuery } from '../ltClientApi'

export const useSelectedClientData: RTKQueryHook<typeof useGetClientQuery> = (args, opts) => {
  const userId = useSelector(getAuthUserId)
  const clientId = useSelector(getSelectedClientId)
  const isSupervisor = useSelector(getAuthIsLTSupervisor)
  const supervisorSelectedProviderId = useSelector(getAuthSupervisorSelectedProviderId)
  return useGetClientQuery(
    clientId
      ? {
          providerId: userId,
          clientId,
          ...args,
        }
      : skipToken,
    { ...opts, skip: isSupervisor && !supervisorSelectedProviderId },
  ) as RTKQueryResultType<typeof useGetClientQuery>
}
